import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { printOrderSummary } from '../../../../store/printing/print.actions';
import Global from '../../../../store/global-selectors';
import { useGetPrintSettingsForDocumentType } from '../../../../hooks/use-get-print-settings-for-document-type';
import { DocumentType } from '../../../../enums/document-type';

export const useOrderSummary = ({ salesOrderId, fulfillmentPlanIds }) => {
  const dispatch = useDispatch();
  const isDisabled = false;
  const salesOrderFulfillmentPlanIds = useSelector((state) =>
    Global.selectEntitiesSalesOrderProperty(state, {
      salesOrderId,
      property: 'fulfillmentPlanIds',
    }),
  );
  const doesPrintSettingExist = !!useGetPrintSettingsForDocumentType(DocumentType.OrderSummary.printSettingKey);

  const onPrint = useCallback(() => {
    dispatch(printOrderSummary(fulfillmentPlanIds ?? salesOrderFulfillmentPlanIds, !doesPrintSettingExist));
  }, [dispatch, fulfillmentPlanIds, salesOrderFulfillmentPlanIds, doesPrintSettingExist]);

  return useMemo(
    () => ({
      isDisabled,
      onPrint,
    }),
    [isDisabled, onPrint],
  );
};
